module.exports = __webpack_public_path__ + "img/R02_03.3b7c3281.jpg";